module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Italic-2f3ebf9363f793a14d7b53944ed08771.woff2";